"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPaymentMethods = void 0;
var tslib_1 = require("tslib");
var PaymentMethod_1 = require("@wix/cashier-core/dist/src/services/PaymentMethod");
var getAccountId_1 = require("./getAccountId");
var fetchPaymentMethods = function (params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var baseURL, appDefId, appInstanceId, auth, paymentMethodsService, paymentMethods;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                baseURL = params.baseURL, appDefId = params.appDefId, appInstanceId = params.appInstanceId, auth = params.auth;
                paymentMethodsService = new PaymentMethod_1.PaymentMethodService(tslib_1.__assign({ baseURL: baseURL }, auth));
                return [4 /*yield*/, paymentMethodsService.fetchExpressPaymentMethods((0, getAccountId_1.getAccountId)(appDefId, appInstanceId))];
            case 1:
                paymentMethods = _a.sent();
                return [2 /*return*/, paymentMethods];
        }
    });
}); };
exports.fetchPaymentMethods = fetchPaymentMethods;
//# sourceMappingURL=fetchPaymentMethods.js.map